module.exports = __webpack_public_path__ + "img/bg-type03.25a54534.png";